import {FC} from 'react'
import {useIntl} from 'react-intl'
import clsx from 'clsx'

type SubmitButtonProps = {
  isLoading: boolean
  isDisabled: boolean
  label: string
  loadingLabel: string
  type?: 'button' | 'submit' | 'reset'
  className?: string
}

const FormSubmitButton: FC<SubmitButtonProps> = ({
  isLoading,
  isDisabled,
  label,
  loadingLabel,
  type = 'submit',
  className,
}) => {
  const intl = useIntl()

  return (
    <div className='col-12 my-3 px-1'>
      <button
        type={type}
        className={clsx('btn btn-primary w-100 h-50px px-0', className)}
        disabled={isDisabled}
      >
        {isLoading ? (
          <span className='indicator-label'>
            {intl.formatMessage({id: loadingLabel})}{' '}
            {/* <span className='spinner-border spinner-border-sm align-middle ms-2'></span> */}
          </span>
        ) : (
          <span className='indicator-label'>{intl.formatMessage({id: label})}</span>
        )}
      </button>
    </div>
  )
}

export default FormSubmitButton
